export enum Sizes {
	desktop = 1200,
	tablet = 1024,
	mobile = 768,
	extraMobile = 540,

	topMenuShowNavBreakpoint = 1070,
	fixedMenuShowNavBreakpoint = 1130,
}
